module.exports = __webpack_public_path__ + "img/Banner.6fd576e3.jpg";